import './LigneAOuvrir.css';

/**
 * Une ligne d'« Ensuite » ou de « Chercher une autre tâche », au téléphone (chantier
 * `telephone-cadre`, ticket 02) : son titre, son pourquoi à droite ; la toucher ouvre sa fiche.
 */
export function LigneAOuvrir({
  titre,
  pourquoi,
  prioritaire = false,
  onOuvrir,
}: {
  titre: string;
  pourquoi: string;
  /** Une ligne de Prioritaire : son pourquoi sur le jaune de Prioritaire. */
  prioritaire?: boolean;
  onOuvrir: () => void;
}) {
  return (
    <button type="button" className="ligne-a-ouvrir" onClick={onOuvrir}>
      <span className="ligne-a-ouvrir-titre">{titre}</span>
      {pourquoi && <span className={`ligne-a-ouvrir-pourquoi${prioritaire ? ' est-prioritaire' : ''}`}>{pourquoi}</span>}
    </button>
  );
}
